import React from 'react';
import { TeaserEntry } from '../helper/interfaces';
import Teaser from './teaser';

type BodyProps = {
  teaser: TeaserEntry
  navigate?: (id?: string, ressortId?: string) => void
}

export default function EventBody(props: BodyProps) {
  return (
    <React.Fragment key={`article-teaser-${props.teaser.id}`}>
      <Teaser
        className="article-teaser"
        teaser={props.teaser}
        navigate={props.navigate}
        ignoreLead={true}
        isArticleTeaser={true}
      />
    </React.Fragment>
  );
}